import React from 'react';
import { createStyles, makeStyles } from '@mui/styles';

import { BaseModal } from './BaseModal';
import { Button } from 'components';

const useStyles = makeStyles(() =>
  createStyles({
    baseModal: {
      padding: '16px 8px 8px 8px !important',
      borderRadius: '20px',
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'center',
      gap: '8px',
      padding: '16px 0',
      width: '100%',
    },
  })
);

type ConfirmModallProps = {
  title: string;
  name: string;
  open: boolean;
  onClose: () => void;
  onProceed: (confirm?: boolean) => void;
};

export const ConfirmModal = ({ onProceed, ...props }: ConfirmModallProps) => {
  const classes = useStyles();
  return (
    <BaseModal className={classes.baseModal} {...props}>
      <div>
        <h4>{props.name}</h4>
        <div className={classes.buttonContainer}>
          <Button color="secondary" sx={{height: '40px', flex: 1}} onClick={() => onProceed(false)}>
            取消
          </Button>
          <Button sx={{height: '40px', flex: 1}} onClick={() => onProceed(true)}>確認</Button>
        </div>
      </div>
    </BaseModal>
  );
};
